module.exports = __webpack_public_path__ + "static/media/Yoyo_8000.264ad6ce.jpg";